import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SnippetService } from '../snippet.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-snippet-grid',
    templateUrl: './snippet-grid.component.html',
    styleUrls: ['./snippet-grid.component.scss']
})
export class SnippetGridComponent implements OnInit {
    @Input() snippet;
    @Output() action: EventEmitter<any> = new EventEmitter<any>();

    env = environment;
    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };


    editMode = true;
    showConfirmation = false;
    snippetEditModal = false;
    showImageLibrary = false;
    imageLibraryType = '';
    col;

    tinyInit = {
        height: 500,
        menubar: false,
        inline: true,
        placeholder: 'Click here to start writing your contents',
        image_dimensions: false,
        image_advtab: true,
        image_class_list: [
            { title: 'None', value: '' },
            { title: 'Fill area', value: 'image-fill' },
            { title: 'Float Left', value: 'cms-image-float-left' },
            { title: 'Float Right', value: 'cms-image-float-right' },
        ],
        plugins: [
            'advlist autolink lists link  image imagetools charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code wordcount'
        ],
        toolbar:
            'undo redo | formatselect | bold italic forecolor backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist | removeformat | image | viewImages |visualblocks | code',
        setup: (editor) => {
            editor.ui.registry.addButton('viewImages', {
                icon: 'gallery',
                tooltip: 'View image gallery',
                onAction: () => {
                    this.viewImageLibrary('cms');
                    setTimeout(() => {
                    }, 100);
                }
            });
        },
    };

    constructor(
        private snippetService: SnippetService,
        private toastrService: ToastrService,
    ) {
    }

    ngOnInit() {
    }

    edit() {
        this.editMode = true;
    }

    cancel() {
        this.editMode = false;
    }

    save() {
        this.editMode = false;
        this.snippetService.saveSnippet(this.snippet).subscribe(data => {
            this.toastrService.success('Page contents updated');
            this.action.emit(true);
        });
    }

    deleteConfirm() {
        this.confirmationData.title = 'Please confirm you would like to remove this section';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;

    }
    confirmAction(e) {
        if (e.action) {
            this.snippetService.deleteSnippet(this.snippet).subscribe(data => {
                this.action.emit(true);
            });
        }
        this.confirmationData.open = false;
    }

    editSnippet() {
        this.snippetEditModal = true;
    }
    editModalAction(e) {
        this.snippetEditModal = false;
        if (e.completed) {
            this.toastrService.success('Page contents updated');
        }
    }

    backgroundImage(col) {
        this.col = col;
        this.viewImageLibrary('bgImage');
    }
    viewImageLibrary(type) {
        this.imageLibraryType = type;
        this.showImageLibrary = true;
    }

    imageSelected(e) {
        this.col.bgImage = e.url;
        this.showImageLibrary = false;
        this.snippetService.saveSnippet(this.snippet).subscribe(data => {
            this.toastrService.success('Page contents updated');
        });
    }
    imageModalAction(e) {
        this.showImageLibrary = false;
    }

}
